import { app } from '../../../../../app';
import { Controller } from './approval-forms-edit.controller';

app.component('requestCenterApprovalFormsEdit', {
    bindings: {
        approvalForms: '<',
        policies: '<',
        companyId: '<',
        approvalForm: '<',
    },
    controller: Controller,
    templateUrl: require('./approval-forms-edit.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/forms/edit/approval-forms-edit.component.js